/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';

import { reducer, initialState, IContext } from './reducers';

const ProviderContext = React.createContext(null);

class GlobalProvider extends Component<any, IContext> {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
      dispatch: action => this.setState(state => reducer(state, action)),
    };
  }

  render(): JSX.Element {
    const {
      state,
      props: { children },
    } = this;
    return (
      <ProviderContext.Provider value={state}>{children}</ProviderContext.Provider>
    );
  }
}

const GlobalConsumer = ProviderContext.Consumer;
export { GlobalProvider, GlobalConsumer };
